import React from 'react';
import {
    useSsSelector as useSelector,
} from '~SpectateStore';
import {
    selectShowBabyBetReceipt,
} from '~Betslip/selectors/betReceiptSelectors';

import ReceiptSingleBet from './ReceiptSingleBet';
import BetDetails from '../../../Baby/BabyBetReceipt/BetDetails';

const BetsSection = ({ bets }) => {
    const showBabyBetReceipt = useSelector(selectShowBabyBetReceipt);

    return bets.map(bet => {
        return (
            showBabyBetReceipt
                ? <BetDetails
                        bet={bet}
                        key={bet.id}
                    />
                : <ReceiptSingleBet
                        bet={bet}
                        key={bet.id}
                />
        );
    });
};

export default BetsSection;
